export default "__VITE_ASSET__Ywd9QOFC__"